import { defineComponent as _defineComponent } from 'vue'
import {
  MessageDataObject,
  useIframeConnection,
} from '@/composables/useIframeConnection';
import {
  iframeBridge,
  isIframeModalType,
  matchesModalCloseMessage,
} from '@/composables/iframeBridgeProtocol';
import { useModalInstance } from '@/composables/useModalInstance';
import { getCurrentInstance, onMounted, ref, watch } from 'vue';
import LIframe from '@/components/LIframe.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'iframeModal',
  props: {
    modalData: null
  },
  setup(__props: any) {

const props = __props as {
  modalData: {
    url: string,
    wrapperClass: string,
    name: string,
    callback?: (eventData: MessageDataObject) => void,
  }
};


const modal = useModalInstance<{}, string>();

const iframeLoading = ref(true);
const isFullscreen = ref(false);
const dialogElement = ref<HTMLElement | null>(null);

onMounted(() => {
  dialogElement.value = getCurrentInstance()?.proxy?.$el?.closest('.v-dialog') as HTMLElement | null;
});

watch(isFullscreen, (val) => {
  if (dialogElement.value) {
    dialogElement.value.classList.toggle('iframe-modal-fullscreen', val);
  }
});

const handleIframeLoad = (event: Event) => {
  iframeLoading.value = false;
};

const { listen } = useIframeConnection();
listen((eventData) => {
  if (iframeBridge.infra.iframeUi.fullscreenOpen.matches(eventData)) {
    isFullscreen.value = true;
    return;
  }

  if (iframeBridge.infra.iframeUi.fullscreenClose.matches(eventData)) {
    isFullscreen.value = false;
    return;
  }

  if (props.modalData.name === eventData.type) {
    if (
      isIframeModalType(props.modalData.name)
      && matchesModalCloseMessage(eventData, props.modalData.name)
    ) {
      modal.closeModal(eventData?.data);
      return;
    }

    if (props.modalData.callback) {
      props.modalData.callback(eventData);
    }
  }
});

return { __sfc: true,props, modal, iframeLoading, isFullscreen, dialogElement, handleIframeLoad, listen, LIframe }
}

})